import React, { useState } from 'react';
import { Info } from 'lucide-react';
import { toast } from 'react-toastify';

const FeedbackModal = ({ isOpen, onClose }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        description: '',
    });

    const [errors, setErrors] = useState({});
    const [submittedOnce, setSubmittedOnce] = useState(false);
    const [loading, setLoading] = useState(false);

    const login = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12"));

    const validateField = (name, value) => {
        if (name === 'name') return value.trim() === '';
        if (name === 'email') return !/\S+@\S+\.\S+/.test(value);
        if (name === 'description') return value.trim() === '';
        return false;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (submittedOnce) {
            setErrors(prev => ({ ...prev, [name]: validateField(name, value) }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmittedOnce(true);

        const nameErr = validateField('name', formData.name);
        const emailErr = validateField('email', formData.email);
        const descriptionErr = validateField('description', formData.description);
        const newErrors = { name: nameErr, email: emailErr, description: descriptionErr };

        setErrors(newErrors);

        if (nameErr || emailErr || descriptionErr) {
            toast.error('Please fix the errors.');
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(`https://100real.xyz/feedback`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    description: formData.description,
                    user_id: "HBTR0007",
                    message: "Feedback"
                })
            });

            if (response.status === 200) {
                toast.success("Thank you for sharing your valuable feedback");
                setFormData({ name: '', email: '', description: '' });
                setErrors({});
                setSubmittedOnce(false);
                onClose();
            } else {
                toast.error("Failed to submit feedback.");
            }
        } catch (error) {
            console.error("Error sending feedback:", error);
            toast.error("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="feed-modal-overlay">
            <div className="feed-modal">
                <button onClick={onClose} className="feed-close-btn">×</button>
                <h2 className='feed-modal-heading'>Send Feedback</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group-fb" style={{ position: 'relative' }}>
                        <label htmlFor="name">Name</label>
                        <input
                            name="name"
                            id="name"
                            type="text"
                            placeholder="Your Name"
                            value={formData.name}
                            onChange={handleChange}
                            className={errors.name ? 'input-error' : ''}
                            style={{ paddingRight: '35px' }}
                        />
                        {errors.name && <Info className="input-icon" style={{
                            position: 'absolute',
                            right: '10px',
                            top: '40px',
                            pointerEvents: 'none',
                            color: 'red',
                        }} />}
                    </div>

                    <div className="form-group-fb" style={{ position: 'relative' }}>
                        <label htmlFor="email">Email</label>
                        <input
                            name="email"
                            id="email"
                            type="email"
                            placeholder="Your Email"
                            value={formData.email}
                            onChange={handleChange}
                            className={errors.email ? 'input-error' : ''}
                            style={{ paddingRight: '35px' }}
                        />
                        {errors.email && <Info className="input-icon" style={{
                            position: 'absolute',
                            right: '10px',
                            top: '40px',
                            pointerEvents: 'none',
                            color: 'red',
                        }} />}
                    </div>

                    <div className="form-group-fb" style={{ position: 'relative' }}>
                        <label htmlFor="description">Message</label>
                        <textarea
                            name="description"
                            id="description"
                            rows={5}
                            placeholder="Your Feedback"
                            value={formData.description}
                            onChange={handleChange}
                            className={errors.description ? 'input-error' : ''}
                            style={{ paddingRight: '35px' }}
                        />
                        {errors.description && <Info className="input-icon" style={{
                            position: 'absolute',
                            right: '10px',
                            top: '40px',
                            pointerEvents: 'none',
                            color: 'red',
                        }} />}
                    </div>

                    <button type="submit" className="submit-btn-fb" disabled={loading}>
                        {loading ? 'Sending...' : 'Send Feedback'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default FeedbackModal;
